import { noop, queryOptions, useQuery } from "@tanstack/react-query";
import { Type } from "typebox";
import * as TypeCompiler from "typebox/compile";
import { ReadonlyArray } from "@/shared/schema/schema.ts";
import { httpChecked } from "@/shared/util/fetch.ts";
import { queryClient } from "@/shared/util/queryClient.tsx";
import { useIsLoggedIn } from "./loggedInStatus.ts";

const schema = ReadonlyArray(Type.String());

const checker = TypeCompiler.Compile(schema);

const queries = {
  active: queryOptions({
    queryKey: ["addons"] as const,
    queryFn: ({ signal }) =>
      httpChecked.get("/addons/active", checker, { signal }),
  }),
};

function useActiveAddons() {
  const isLoggedIn = useIsLoggedIn();

  return useQuery({
    ...queries.active,
    select: (data) => new Set(data),
    staleTime: 30_000,
    refetchInterval: 60_000,
    enabled: isLoggedIn === true,
  });
}

export function useIsAuditLogEnabled() {
  const { data } = useActiveAddons();

  if (!data) {
    return false;
  }

  return data.has("Audit Log");
}

export function useIsGenerativeAiEnabled() {
  const { data } = useActiveAddons();

  if (!data) {
    return false;
  }

  return data.has("Generative AI");
}

export async function prefetchActiveAddons() {
  // eslint-disable-next-line unicorn/prefer-await
  await queryClient.query({ ...queries.active, staleTime: 60_000 }).catch(noop);
}
